import { Fragment } from "react";
import { coreBlocks } from "./coreBlocks";
import { jltBlocks } from "./jltBlocks";
import { masterBlocks } from "./masterBlocks";

const gutenbergBlocks = {
  ...coreBlocks,
  ...jltBlocks,
  ...masterBlocks,
};

// type Props = { blocks: any, config: { generateHeadingID: true } }
export const BlockRenderer = ({ blocks, config = {} }) => {
  return blocks?.map((block, i) => {
    const renderBlock = gutenbergBlocks?.[block?.name];
    const key = block?.clientId ?? block?.id ?? `${block?.name}-${i}`;

    if (typeof renderBlock === "function") {
      return <Fragment key={key}>{renderBlock(block, config)}</Fragment>;
    }

    console.warn(`No renderer for block: ${block?.name}`);
    return null;
  });
};
